import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import Coaching from "@/pages/Coaching";
import RoadMap from "@/pages/RoadMap";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/road-map" element={<RoadMap />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
